import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DiversifyPortfolioUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult() {
        return await this.repo.getDiversifyPortfolio();
    }
}
export default DiversifyPortfolioUseCase;
